import { Component, HostListener, OnInit, ElementRef, Output, Input, EventEmitter } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { SubmitgyanService } from './../../core/services/submit-gyan/submitgyan.service';
import { ToastrService } from 'ngx-toastr';
import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef } from '@angular/core';
import { mksMITOCWData } from '../../shared/json/mksMITOCWData';
import { environment } from './../../../environments/environment';
import { SanitizeService } from 'src/app/shared/services/sanitize.service';
import { PreviousDataService } from 'src/app/core/services/previous-gyan/previous-data.service';
import { CommonServiceService } from 'src/app/core/services/common-service/common-service.service';
import { debounceTime, map } from 'rxjs/operators';
import { Subject, forkJoin, Observable, Subscription } from 'rxjs';

interface Sources {
    repoIds: { [key: string]: any };
    repoAvailable: boolean;
    knowledgeStoreIds: { [key: string]: any };
    webAvailable: boolean;
    favouriteWebsites: Array<string>;
    dispreferredWebsites: Array<string>;
    includeSubTopic: { [key: string]: boolean };
}

interface Topic {
    name: string;
    id: number;
    isOrganisationalLabel: boolean;
    isArticleCountToZero: boolean;
    keyConcept: [];
    subtopics: [];
    sources: Array<any>;
    sourceParams: any;
    sourcesSubTopic: any;
    exportDocumentRules: any;
    parentSearchContextList: Array<number>;
    parentRelContextList: Array<number>;
    globalRelevance: boolean;
    processNonArticles: boolean;
    skipRelevance: boolean;
    suppressSummary: boolean;
    suppressMDS?: boolean;
    ignoreProcess?: boolean;
    dor?: any;
    intentScore?: any;
    level: number;
    showAddIcon: boolean;
    ParentList: Array<number>;
    ParentValueChanged: boolean;
    isTemplate: boolean;
}

@Component({
    selector: 'app-my-knowledge-store',
    templateUrl: './my-knowledge-store.component.html',
    styleUrls: ['./my-knowledge-store.component.scss'],
})
export class MyKnowledgeStoreComponent implements OnInit {
    private searchSubject: Subject<string> = new Subject();
    sharedLibrary: any;
    myLibrary: any;
    myKnowledgeStoreArray = [];
    myKnowledgeStoreData: any;
    myKnowledgeStoreSelected: any;
    checkedListMyKnowledgeStore: any;
    isMobile = false;
    findBySearchNameValue = '';
    allowSearch = true;

    apiResponse: any;
    form: FormGroup;
    selectedKnowledgeStore: any = null;
    isLoadingTags: boolean = false;
    minDateTo: string = '';
    maxDateFrom: string = '';

    optionCtrl = new FormControl();
    maxVisibleBadges = 2;
    removedFieldKey: string | null = null; // Property to track the removed field key
    @Input() topic!: any;
    private modalRef: NgbModalRef | undefined;
    mksMITOCWData = mksMITOCWData;
    @Output() sendCheckedListMKS = new EventEmitter<void>();
    topicOutline: Topic | any;
    @Input() gksLevel: string = 'gyanLevel';
    //isIncludeSubtopic = false;
    @Input() flagFromSubmitGyan: boolean = true;
    getTemplateSubsSources: Subscription | undefined;
    getTemplateSourcesSubTopics: Subscription | undefined;

    constructor(
        private previousDataService: PreviousDataService,
        private commonservice: CommonServiceService,
        private sanitizeService: SanitizeService,
        private toastr: ToastrService,
        private submitgyanService: SubmitgyanService,
        private modalService: NgbModal,
        private fb: FormBuilder,
        private eRef: ElementRef,
        private cdr: ChangeDetectorRef,
    ) {
        this.form = this.fb.group({
            fields: this.fb.array([]),
            isIncludeSubtopic: [true],
        });

        // this.filteredOptions = this.allOptions;
    }

    ngOnInit() {
        this.checkWidth();
        if (this.flagFromSubmitGyan) this.checkAndAddSourcesToLocalStorage();
        this.getIndexedRepositories();
    }

    callingSubjects() {
        //this subject is for main sources
        this.getTemplateSubsSources = this.commonservice.templateDataSubjectForSources$.subscribe((sources: any) => {
            //console.log('sources', Object.keys(sources).length);
            if (sources !== null && Object.keys(sources).length > 0) {
                console.log('sources is', sources);
                console.log('this.filteredData is', this.filteredData);
                const localStorageKey = 'myKnowledgeStore';

                this.convertDataToFormData(localStorageKey, sources.repoIds).subscribe((convertedData) => {
                    console.log('Transformed Data:', convertedData);
                    // Store the transformed data in localStorage
                    localStorage.setItem(localStorageKey, JSON.stringify(convertedData));
                    // Perform additional actions, such as retrieving sources from localStorage
                    //     this.getSourcesFromLocalStorage();
                });
            }
        });

        //this subject is for subtopic sources
        this.getTemplateSourcesSubTopics = this.commonservice.templateDataSubjectForTopicOutline$.subscribe((topicOutline: any) => {
            if (topicOutline) {
                console.log('topicOutline-fromsubject', topicOutline);
                const localStorageKeyGK = 'subtopicSource_myKnowledgeStore';
                //this.processAndStoreSubtopicsWithApi(topicOutline, localStorageKeyGK);

                // getting data from topic and subtopics
                const flatData = this.flattenTopics(topicOutline);
                console.log('Flattened Data:', flatData);

                // transforming data
                this.transformKnowledgeStore(flatData).subscribe((transformedData) => {
                    console.log('Transformed Data:', transformedData);

                    this.rebuildAndStore(transformedData, localStorageKeyGK);
                });
            }
        });
    }

    checkAndAddSourcesToLocalStorage(): void {
        const localStorageKey = 'sources';
        if (!localStorage.getItem(localStorageKey)) {
            // if not exists create an empty Sources object
            const sources: Sources = {
                repoIds: {},
                repoAvailable: false,
                knowledgeStoreIds: {},
                webAvailable: false,
                favouriteWebsites: [],
                dispreferredWebsites: [],
                includeSubTopic: {},
            };
            localStorage.setItem(localStorageKey, JSON.stringify(sources));
            console.log('sources added to localStorage:', sources);
        } else {
            console.log('sources already exist in localStorage.');
        }
    }
    callFindBySearchNameService(value: any) {
        // Call the service method after the debounce
        this.previousDataService.emitCallFindByNameClickEvent(value);
    }
    getIndexedRepositories() {
        console.log('getIndexedRepositories called');
        this.submitgyanService.getIndexedRepositories(1).subscribe((res) => {
            console.log(res);
            this.sharedLibrary = res['Shared'];
            this.myLibrary = res['My Library'];
            // console.log('this.myLibrary', this.myLibrary);
            if (this.sharedLibrary.length > 0) {
                this.myKnowledgeStoreArray = this.sharedLibrary.concat(this.myLibrary);
            } else {
                this.myKnowledgeStoreArray = this.myLibrary;
            }
            //            console.log('myKnowledgeStoreArray', this.myKnowledgeStoreArray);
            this.getMyFiles();
        });
    }

    flattenTopics(topic: any, flatData: any = {}): any {
        if (!flatData[topic.id]) {
            flatData[topic.id] = topic.sourcesSubTopic?.repoIds || {};
        }

        if (Array.isArray(topic.subtopics)) {
            topic.subtopics.forEach((subtopic: any) => this.flattenTopics(subtopic, flatData));
        }

        return flatData;
    }

    transformKnowledgeStore(flatData: any): Observable<any> {
        const transformedData: any = {};
        const apiCalls: Array<Observable<any>> = [];

        Object.keys(flatData).forEach((topicId) => {
            transformedData[topicId] = {};

            Object.keys(flatData[topicId]).forEach((knowledgeStoreId) => {
                const dynamicData = flatData[topicId][knowledgeStoreId];

                let sitename = '';
                this.filteredData.map((item: { uuid: string; siteName: string }) => {
                    if (item.uuid === knowledgeStoreId) {
                        sitename = item.siteName;
                    }
                });
                console.log(sitename);
                // const apiCall = this.submitgyanService.getRepoTags(siteName).pipe(
                const apiCall = this.submitgyanService.getRepoTags(sitename).pipe(
                    map((response: any) => {
                        const apiResponse = response || [];

                        const fields = Object.keys(dynamicData || {}).map((fieldKey) => {
                            const fieldData = dynamicData[fieldKey];
                            let dateFieldFrom = '';
                            let dateFieldTo = '';
                            console.log('fieldData', fieldData, fieldKey);
                            // handling Date fields
                            if ((fieldData.DT === 'date' || fieldData.DT === 'datetime') && fieldData.V?.length > 0) {
                                dateFieldFrom = new Date(fieldData.V[0]).toISOString().split('T')[0];
                                dateFieldTo = new Date(fieldData.V[fieldData.V.length - 1]).toISOString().split('T')[0];
                            }

                            // Map additional data into `key`
                            const matchingTag = apiResponse.find((tag: any) => tag.id === fieldKey) || {};
                            const additionalField: any = {
                                id: matchingTag.id || '',
                                tagName: matchingTag.tagName || '',
                                idWithoutSite: matchingTag.idWithoutSite || '',
                                dataType: matchingTag.dataType || fieldData.DT || '',
                            };

                            return {
                                key: additionalField,
                                tagValues: fieldData.V ? fieldData.V.join(', ') : '',
                                dataType: fieldData.DT || '',
                                dateFieldFrom,
                                dateFieldTo,
                                optionCtrl: '',
                                filteredOptions: [],
                                showDropdown: !!fieldData.V,
                                selectedOptions: fieldData.V || [],
                                id: '',
                            };
                        });

                        // adding an empty field at the end
                        fields.push({
                            key: '',
                            tagValues: '',
                            dataType: '',
                            dateFieldFrom: '',
                            dateFieldTo: '',
                            optionCtrl: '',
                            filteredOptions: [],
                            showDropdown: false,
                            selectedOptions: [],
                            id: '',
                        });

                        transformedData[topicId][knowledgeStoreId] = {
                            apiResponse,
                            formData: {
                                fields,
                                isIncludeSubtopic: true,
                            },
                        };
                    }),
                );

                apiCalls.push(apiCall);
            });
        });

        return forkJoin(apiCalls).pipe(map(() => transformedData));
    }

    rebuildAndStore(transformedData: any, localStorageKey: string): void {
        localStorage.setItem(localStorageKey, JSON.stringify(transformedData));
        console.log('Final Data in LocalStorage:', transformedData);
    }

    //converting date back to original
    formatDate(dateString: string): string {
        const date = new Date(dateString);
        return date.toISOString().split('T')[0];
    }

    //converting data for sources in localstorage
    convertDataToFormData(localStorageKey: any, inputData: any) {
        console.log('inputData', inputData);

        const apiCalls: Array<Observable<any>> = [];
        const convertedData: any = {};

        // Iterate over inputData keys
        Object.keys(inputData).forEach((key) => {
            const dynamicData = inputData[key];
            console.log('Processing Key:', key, 'Dynamic Data:', dynamicData);

            console.log('this.filteredData', this.filteredData);
            let sitename = '';
            this.filteredData = this.filteredData.map((item: { uuid: string; siteName: string }) => {
                if (item.uuid === key) {
                    sitename = item.siteName;
                    return { ...item, checked: true };
                }
                return item;
            });
            console.log('---sitename---', sitename);
            //this.filteredData.find((item: { uuid: any; }) => item.uuid === uuid)?.siteName || null;

            // Make API call for this key
            const apiCall = this.submitgyanService.getRepoTags(sitename).pipe(
                map((response: any) => {
                    const apiResponse = response; // Assuming the response contains `tags`

                    const fields = apiResponse
                        .filter((tag: any) => dynamicData && dynamicData[tag.id])
                        .map((matchingTag: any) => {
                            const fieldData = dynamicData[matchingTag.id];

                            // Handle Date Type: Split into dateFieldFrom and dateFieldTo
                            let dateFieldFrom = '';
                            let dateFieldTo = '';
                            if ((fieldData.DT === 'datetime' || fieldData.DT === 'date') && fieldData.V?.length > 0) {
                                dateFieldFrom = this.formatDate(fieldData.V[0]) || '';
                                dateFieldTo = this.formatDate(fieldData.V[fieldData.V.length - 1]) || '';
                            }

                            //key for mks
                            const additionalField = {
                                id: matchingTag.id || '',
                                tagName: matchingTag.tagName || '',
                                idWithoutSite: matchingTag.idWithoutSite || '',
                                dataType: matchingTag.dataType || '',
                            };

                            return {
                                key: additionalField,
                                tagValues: fieldData.V ? fieldData.V.join(', ') : '',
                                dataType: fieldData.DT || matchingTag.dataType || '',
                                dateFieldFrom: dateFieldFrom,
                                dateFieldTo: dateFieldTo,
                                optionCtrl: '',
                                filteredOptions: [],
                                showDropdown: !!fieldData.V,
                                selectedOptions: fieldData.V || [],
                                id: '',
                            };
                        });

                    // Add an empty field at the end
                    fields.push({
                        key: '',
                        tagValues: '',
                        dataType: '',
                        dateFieldFrom: '',
                        dateFieldTo: '',
                        optionCtrl: '',
                        filteredOptions: [],
                        showDropdown: false,
                        selectedOptions: [],
                        id: '',
                    });

                    // Assign the final transformed data
                    convertedData[key] = {
                        apiResponse: apiResponse,
                        formData: {
                            fields:
                                fields.length > 1
                                    ? fields
                                    : [
                                          {
                                              key: '',
                                              tagValues: '',
                                              dataType: '',
                                              dateFieldFrom: '',
                                              dateFieldTo: '',
                                              optionCtrl: '',
                                              filteredOptions: [],
                                              showDropdown: false,
                                              selectedOptions: [],
                                              id: '',
                                          },
                                      ],
                            isIncludeSubtopic: true,
                        },
                    };
                }),
            );

            apiCalls.push(apiCall);
        });

        // Wait for all API calls to complete
        return forkJoin(apiCalls).pipe(
            map(() => {
                // Store the transformed data in localStorage
                localStorage.setItem(localStorageKey, JSON.stringify(convertedData));
                return convertedData;
            }),
        );
    }

    getMyFiles() {
        if (this.myKnowledgeStoreArray) {
            this.myKnowledgeStoreData = JSON.parse(JSON.stringify(this.myKnowledgeStoreArray));
            this.filteredData = [...this.myKnowledgeStoreData];
            this.onFilterDataSort();
            const envData = mksMITOCWData.find((item) => item.env === environment.type)?.data || [];
            this.myKnowledgeStoreData = this.myKnowledgeStoreData.filter((item: any) => !envData.some((mitItem: any) => mitItem.id === item.uuid));
            this.filteredData = [...this.myKnowledgeStoreData];
            this.onFilterDataSort();
            // this.myKnowledgeStoreData = this.myKnowledgeStoreData.filter((item: any) => !mksMITOCWData.some((mitItem) => mitItem.id === item.uuid));
            if (this.flagFromSubmitGyan) this.callingSubjects();
            if (this.topic) {
                const includeSubTopic = this.topic.sourcesSubTopic.includeSubTopic;
                console.log('mks', includeSubTopic);
                this.myKnowledgeStoreData = this.myKnowledgeStoreData.map((item: any) => ({
                    ...item,
                    checked: item.uuid in includeSubTopic,
                }));
                this.filteredData = [...this.myKnowledgeStoreData];
                this.onFilterDataSort();
            }

            if (this.gksLevel == 'gyanLevel') {
                const sources = localStorage.getItem('sources');
                const parsedSources = sources ? JSON.parse(sources) : {};
                console.log('sourcesMKS', parsedSources);

                const storedIds = Object.keys(parsedSources?.repoIds || {});

                this.myKnowledgeStoreData = this.myKnowledgeStoreData.map((item: any) => ({
                    ...item,
                    checked: storedIds.includes(item.uuid),
                }));
                this.filteredData = [...this.myKnowledgeStoreData];
                this.onFilterDataSort();
            }
        }
    }

    isMyKnowledgeStoreSelected(event: any, ischecked: any, myKnowledgeStoreUUID: any) {
        //    console.log('isMyKnowledgeStoreSelected');
        this.myKnowledgeStoreSelected = this.filteredData.every(function (item: any) {
            return item.checked === true;
        });

        console.log('The lists', ischecked);
        //this.getCheckedItemMyKnowledgeStore();
        if (this.gksLevel == 'topicLevel') {
            if (ischecked) this.IncludeSubtopic(myKnowledgeStoreUUID, true, false);
            else this.IncludeSubtopic(myKnowledgeStoreUUID, true, true);
        }
        this.updateSourcesWithCheckbox(myKnowledgeStoreUUID, ischecked);
    }

    //this is for only checking checkboxes
    updateSourcesWithCheckbox(myKnowledgeStoreUUID: string, ischecked: boolean) {
        const localStorageKey = 'sources';
        const sources = localStorage.getItem(localStorageKey)
            ? JSON.parse(localStorage.getItem(localStorageKey)!)
            : {
                  repoIds: {},
                  repoAvailable: false,
                  knowledgeStoreIds: {},
                  webAvailable: false,
                  favouriteWebsites: [],
                  dispreferredWebsites: [],
                  includeSubTopic: {},
              };
        if (this.gksLevel == 'topicLevel') {
            const localStorageKey_topicOutline = 'topicOutline';
            const topicOutline = localStorage.getItem(localStorageKey_topicOutline) ? JSON.parse(localStorage.getItem(localStorageKey_topicOutline)!) : this.topicOutline;

            function updateKnowledgeStore(topicOutline: any, gksLevel: string, isChecked: boolean, gyanId: string, currentTopicId: number) {
                function handleTopicLevel(outline: any) {
                    const repoIds = outline.sourcesSubTopic.repoIds;
                    if (isChecked && repoIds[gyanId] == undefined) {
                        if (!repoIds[gyanId]) {
                            repoIds[gyanId] = {};
                        }
                    } else {
                        if (JSON.stringify(repoIds[gyanId]) === '{}' && Object.keys(repoIds[gyanId]).length === 0) {
                            delete repoIds[gyanId];
                        }
                    }
                }

                function processOutline(outline: any) {
                    // Check if the current outline's ID matches the current topic ID
                    if (outline.id === currentTopicId && gksLevel === 'topicLevel') {
                        handleTopicLevel(outline);
                        console.log(outline);
                    } else if (outline.subtopics && outline.subtopics.length > 0) {
                        // Continue the search in nested subtopics if the ID doesn't match
                        outline.subtopics.forEach((subtopic: any) => processOutline(subtopic));
                    }
                }

                // Start processing from the root topicOutline
                processOutline(topicOutline);
            }

            updateKnowledgeStore(topicOutline, this.gksLevel, ischecked, myKnowledgeStoreUUID, this.topic.id);
            localStorage.setItem(localStorageKey_topicOutline, JSON.stringify(topicOutline));
        } else if (ischecked && sources.repoIds[myKnowledgeStoreUUID] == undefined) {
            sources.repoIds[myKnowledgeStoreUUID] = {};
        } else {
            if (JSON.stringify(sources.repoIds[myKnowledgeStoreUUID]) == '{}') {
                ischecked && Object.values(sources.repoIds[myKnowledgeStoreUUID]).length == 0
                    ? (sources.repoIds[myKnowledgeStoreUUID] = {})
                    : delete sources.repoIds[myKnowledgeStoreUUID];
            }
        }

        localStorage.setItem(localStorageKey, JSON.stringify(sources));
        this.sendCheckedListMKS.emit();
    }

    // getCheckedItemMyKnowledgeStore() {
    //     this.checkedListMyKnowledgeStore = this.myKnowledgeStoreData.filter((itm: any) => itm.checked === true);
    // //    this.sendCheckedListMKS.emit(this.checkedListMyKnowledgeStore); //sending to parent submit component
    // }

    showPopup(myKnowledgeStore: any, content: any): void {
        console.log('showing popup', myKnowledgeStore);
        this.selectedKnowledgeStore = myKnowledgeStore;
        myKnowledgeStore.checked = true;
        this.updateSourcesWithCheckbox(myKnowledgeStore.uuid, myKnowledgeStore.checked);
        console.log(this.selectedKnowledgeStore);
        if (this.gksLevel == 'topicLevel') {
            this.IncludeSubtopic(myKnowledgeStore.uuid, true, false);
        }
        // if (this.gksLevel == 'topicLevel') {
        //     this.isIncludeSubtopic = true;
        // }
        //this.selectedRepoName = this.selectedKnowledgeStore.name;
        const localStorageKey = 'myKnowledgeStore';
        const localStorageData = localStorage.getItem(localStorageKey);

        const localStorageKeyMK = 'subtopicSource_myKnowledgeStore';
        const localStorageDataMK = localStorage.getItem(localStorageKeyMK);
        const parsedDataMK = localStorageDataMK ? JSON.parse(localStorageDataMK) : null;

        console.log(localStorageData);
        this.isLoadingTags = false;
        if (localStorageData && this.gksLevel == 'gyanLevel') {
            // Load data from local storage
            this.loadDataFromLocalStorage(localStorageData, myKnowledgeStore.uuid, myKnowledgeStore.siteName);
            //this.isLoadingTags = true;
        } else if (this.topic !== undefined && parsedDataMK && parsedDataMK[this.topic?.id] && this.gksLevel == 'topicLevel') {
            // Load data from local storage
            this.loadDataFromLocalStorage(localStorageDataMK, myKnowledgeStore.uuid, myKnowledgeStore.siteName);
            //this.isLoadingTags = true;
        } else {
            //this.getTags(myKnowledgeStore.uuid)
            //this.submitgyanService.getTags(myKnowledgeStore.uuid).subscribe((response) => {
            this.callAPIGetRepoTags(myKnowledgeStore.siteName);
        }

        console.log('show popup', myKnowledgeStore.siteName);
        this.modalRef = this.modalService.open(content, { size: 'lg' }); // centered: true, animation: true
    }

    loadDataFromLocalStorage(localStorageData: any, myKnowledgeStore: any, siteName: any): void {
        if (localStorageData) {
            const parsedData = JSON.parse(localStorageData);
            console.log(parsedData);
            if (parsedData[myKnowledgeStore] && this.gksLevel == 'gyanLevel') {
                this.apiResponse = parsedData[myKnowledgeStore].apiResponse;
                console.log(this.apiResponse);
                this.initializeForm(parsedData[myKnowledgeStore].formData);
                this.isLoadingTags = true;
            } else if (this.topic?.id && parsedData[this.topic?.id] && this.gksLevel == 'topicLevel') {
                if (parsedData[this.topic.id][myKnowledgeStore] == undefined) {
                    this.callAPIGetRepoTags(siteName);
                } else {
                    this.apiResponse = parsedData[this.topic?.id][myKnowledgeStore].apiResponse;
                    console.log(this.apiResponse);
                    this.initializeForm(parsedData[this.topic?.id][myKnowledgeStore].formData);
                    this.isLoadingTags = true;
                    const includeSubTopic = this.topic.sourcesSubTopic.includeSubTopic;
                    this.form.patchValue({
                        isIncludeSubtopic: includeSubTopic[this.selectedKnowledgeStore.uuid], // Set to true or false as needed
                    });
                }
            } else {
                console.log('uuid not found in localstorage');
                this.callAPIGetRepoTags(siteName);
                //this.initializeForm(); // Initialize an empty form if no data found
            }
            // this.apiResponse = parsedData.apiResponse;
            // console.log(this.apiResponse);
            // this.initializeForm(parsedData.formData);
        } else {
            this.initializeForm(); // Initialize an empty form if no data found
        }
    }

    callAPIGetRepoTags(siteName: any) {
        this.submitgyanService.getRepoTags(siteName).subscribe((response) => {
            console.log('this.apiRespnse: ', response);
            this.apiResponse = response;
            this.initializeForm();
            // this.saveApiResponseToLocalStorage(myKnowledgeStore.uuid, response);
            this.isLoadingTags = true;
        });
    }

    onDateFromChange(event: any): void {
        const selectedDate = event.target.value;
        this.minDateTo = selectedDate;
    }

    onDateToChange(event: any): void {
        const selectedDate = event.target.value;
        this.maxDateFrom = selectedDate;
    }

    get fields(): FormArray {
        return this.form.get('fields') as FormArray;
    }

    apiResponseKeys(): Array<{ id: string; tagName: string; idWithoutSite: string }> {
        return this.apiResponse
            ? this.apiResponse.map((tag: any) => ({
                  id: tag.id,
                  tagName: tag.tagName,
                  idWithoutSite: tag.idWithoutSite,
                  dataType: tag.dataType,
              }))
            : [];
    }
    compareTags(tag1: any, tag2: any): boolean {
        return tag1 && tag2 ? tag1.id === tag2.id : tag1 === tag2;
    }

    initializeForm(formData: any = null): void {
        const fieldsArray = formData ? formData.fields.map((field: any) => this.addFormField(field)) : [this.addFormField()];
        this.form = this.fb.group({
            fields: this.fb.array(fieldsArray),
            isIncludeSubtopic: [true],
        });
    }

    removeFormField(index: number): void {
        this.removedFieldKey = this.fields.at(index).get('key')?.value; // Store the removed field key

        this.fields.removeAt(index);
        if (this.fields.length === 0) {
            this.fields.push(this.addFormField());
        } else if (this.fields.length < Object.keys(this.apiResponse).length) {
            // Ensure only one new empty field is always present
            while (this.fields.length < Object.keys(this.apiResponse).length && this.fields.controls.some((control) => control.get('key')?.value === '')) {
                this.fields.removeAt(this.fields.length - 1);
            }
            this.fields.push(this.addFormField());
        }
    }

    addFormField(fieldData: any = null): FormGroup {
        console.log('Adding field with data:', fieldData);
        const fieldGroup = this.fb.group({
            key: [fieldData ? fieldData.key : '', Validators.required],
            value: [fieldData ? fieldData.value : []], // updated to support array for multiple values
            dataType: [fieldData ? fieldData.dataType : ''],
            dateFieldFrom: [fieldData ? fieldData.dateFieldFrom : ''],
            dateFieldTo: [fieldData ? fieldData.dateFieldTo : ''],
            optionCtrl: [fieldData ? fieldData.optionCtrl : ''], // separate option control for each field
            filteredOptions: [fieldData ? fieldData.filteredOptions : []], // initialize empty filteredOptions
            showDropdown: [fieldData ? fieldData.showDropdown : false], // track dropdown visibility for each field
            selectedOptions: [fieldData ? fieldData.selectedOptions : []], // store selected options for each field
            id: [fieldData ? fieldData.id : ''],
        });

        // If key is already selected, disable the select box
        if (fieldData && fieldData.key) {
            fieldGroup.get('key')?.disable();
        }

        return fieldGroup;
    }

    onKeyChange(index: number) {
        const selectedKey = this.fields.at(index).get('key')?.value;
        console.log(selectedKey);
        const selectedTag = this.apiResponse.find((tag: { idWithoutSite: any }) => tag.idWithoutSite === selectedKey.idWithoutSite);
        console.log(selectedTag);
        if (!selectedTag) return;

        const fieldGroup = this.fields.at(index) as FormGroup;
        const selectedTagID = selectedTag.id;
        //   const isMultiValue = selectedTag.isMultiValue
        const dataType = selectedTag.dataType;
        //https://download-utility.gyan-research.com/solr/properties/query?fl=country&indent=true&q.op=OR&q=country%3Ae*%20AND%20repoId%3Ac908e307-75ed-46fd-8689-97be17628931&rows=100&wt=csv

        fieldGroup.patchValue({
            key: selectedKey,
            value: '', //dataType === 'text' ? '' : '',
            dataType: dataType,
            dateFieldFrom: '',
            dateFieldTo: '',
            id: selectedTagID,
        });

        console.log('Field Group after patching:', fieldGroup.value);

        //fieldGroup.get('key')?.disable();
        setTimeout(() => {
            fieldGroup.get('key')?.disable();
        }, 10);
        this.cdr.detectChanges(); // Force change detection

        // Add new field if there are remaining values and fields length is less than API response keys
        if (this.fields.length < Object.keys(this.apiResponse).length) {
            //remainingValues.length > 0 &&
            this.fields.push(this.addFormField());
        }
    }

    // isKeyDisabled(idWithoutSite: string) {
    //     return this.fields.controls.some((control) => control.get('key')?.value === idWithoutSite);
    // }

    isKeyDisabled(idWithoutSite: string): boolean {
        return this.fields.controls.some((control) => control.get('key')?.value?.idWithoutSite === idWithoutSite);
    }

    saveFormToLocalStorage(uuid: string): void {
        const localStorageKey = 'myKnowledgeStore';
        const localStorageKeyMK = 'subtopicSource_myKnowledgeStore';
        const formData = this.getEnabledFormData();

        const errorMessages: Array<string> = [];

        formData.fields.forEach((field: any) => {
            if (field.dataType !== '') {
                // checking if selectedOptions is empty
                if (field.dataType?.toLowerCase() === 'text' && field.selectedOptions.length === 0) {
                    errorMessages.push(`Please select at least one tag for "${field.key.tagName}" before saving.`);
                }

                // checking for empty dates
                if ((field.dataType?.toLowerCase() === 'date' || field.dataType?.toLowerCase() === 'datetime') && (field.dateFieldFrom === '' || field.dateFieldTo === '')) {
                    errorMessages.push(`Please enter both dates for " ${field.key.tagName} ."`);
                }
            }
        });

        // if error then showing toast
        if (errorMessages.length > 0) {
            this.toastr.warning(errorMessages.join(' '), 'Validation Error');
            return;
        }

        //selectOptions can be stored as comma separated in values
        formData.fields.forEach((field: any) => {
            // Check if selectedOptions has values
            if (field.selectedOptions && field.selectedOptions.length > 0) {
                // Store the selectedOptions as a comma-separated string in value
                field.value = field.selectedOptions.join(', ');
            }
        });

        const dataToSave = {
            apiResponse: this.apiResponse,
            formData: formData,
        };

        if (this.gksLevel == 'gyanLevel') {
            const knowledgeStore = localStorage.getItem(localStorageKey) ? JSON.parse(localStorage.getItem(localStorageKey)!) : {};
            knowledgeStore[uuid] = dataToSave;
            //console.log(knowledgeStore);
            localStorage.setItem(localStorageKey, JSON.stringify(knowledgeStore));
        } else {
            const knowledgeStore = localStorage.getItem(localStorageKeyMK) ? JSON.parse(localStorage.getItem(localStorageKeyMK)!) : {};

            if (!knowledgeStore[this.topic.id]) {
                // If not, initialize it as an empty object
                knowledgeStore[this.topic.id] = {};
            }
            knowledgeStore[this.topic.id][uuid] = dataToSave;
            localStorage.setItem(localStorageKeyMK, JSON.stringify(knowledgeStore));
            this.IncludeSubtopic(uuid, false, false);
        }
        // Now, update the main knowledgeStore key
        this.saveTransformedDataToLocalStorage();
        //this.modalService.dismissAll();
        if (this.modalRef) {
            this.modalRef.close();
        }
    }

    // Method to convert date to ISO format
    convertToISO(date: Date): string {
        return date.toISOString();
    }

    saveTransformedDataToLocalStorage(): void {
        const localStorageKey = 'sources';
        const knowledgeStoreKey = 'myKnowledgeStore';
        const transformedData = localStorage.getItem(localStorageKey)
            ? JSON.parse(localStorage.getItem(localStorageKey)!)
            : {
                  repoIds: {}, // store the transformed data here
                  repoAvailable: false,
                  knowledgeStoreIds: {},
                  webAvailable: false,
                  favouriteWebsites: [],
                  dispreferredWebsites: [],
                  includeSubTopic: {},
              };

        const knowledgeStoreData = localStorage.getItem(knowledgeStoreKey);
        if (!knowledgeStoreData) {
            console.log('No knowledgeStore data found.');
            return;
        }

        const parsedKnowledgeStore = JSON.parse(knowledgeStoreData);

        // loop over each UUID in the knowledgeStore data
        for (const uuid in parsedKnowledgeStore) {
            if (parsedKnowledgeStore.hasOwnProperty(uuid)) {
                const mksIds = uuid;
                const formData = parsedKnowledgeStore[uuid].formData;
                console.log('formData : ', formData);
                // Filter out the removed field from formData, if any
                if (this.removedFieldKey) {
                    formData.fields = formData.fields.filter((field: any) => field.key !== this.removedFieldKey);
                    console.log(formData.fields);
                    parsedKnowledgeStore[uuid].formData = formData;
                }
                console.log('formData', formData);
                formData.fields.forEach((field: any) => {
                    const fieldKey = field.id;
                    const dataType = field.dataType;
                    let values: any = [];

                    // text splitting string into an array
                    if (dataType === 'text') {
                        const rawValues = field.value || ''; // The values stored in the form (string or array)
                        values = typeof rawValues === 'string' ? rawValues.split(',').map((value: string) => value.trim()) : rawValues;
                    }

                    // Date type by storing dateFieldFrom and dateFieldTo as an array
                    if (dataType === 'date') {
                        values = [this.convertToISO(new Date(field.dateFieldFrom)), this.convertToISO(new Date(field.dateFieldTo))]; // Store the date range in an array
                    }

                    // initiate the entry for repoIds if it doesn't exist
                    if (values && values.length > 0 && values.some((value: any) => value)) {
                        if (!transformedData.repoIds[mksIds]) {
                            transformedData.repoIds[mksIds] = {};
                        }

                        if (!transformedData.repoIds[mksIds][fieldKey]) {
                            transformedData.repoIds[mksIds][fieldKey] = {
                                DT: dataType,
                                V: [],
                            };
                        }

                        // merge and avoid duplicates
                        transformedData.repoIds[mksIds][fieldKey].V = [...new Set([...transformedData.repoIds[mksIds][fieldKey].V, ...values])];
                    }
                });

                // Remove the field from sources if a field was removed
                if (this.removedFieldKey && transformedData.repoIds[mksIds]) {
                    delete transformedData.repoIds[mksIds][this.removedFieldKey];
                }
            }
        }

        //  save to sources in localstorage
        localStorage.setItem(localStorageKey, JSON.stringify(transformedData));
        localStorage.setItem(knowledgeStoreKey, JSON.stringify(parsedKnowledgeStore));

        console.log('Transformed Data saved to localStorage:', transformedData);
        // Reset the removedFieldKey after the cleanup is done
        this.removedFieldKey = null;
    }

    IncludeSubtopic(id: string, fromAutoCheck: boolean, removeChecked: boolean) {
        const isChecked = fromAutoCheck ? true : this.form.get('isIncludeSubtopic')?.value;
        const localStorageKey_topicOutline = 'topicOutline';
        const topicOutline = localStorage.getItem(localStorageKey_topicOutline) ? JSON.parse(localStorage.getItem(localStorageKey_topicOutline)!) : this.topicOutline;

        function updateIncludeSubtopic(topicOutline: any, gksLevel: string, isChecked: boolean, gyanId: string, currentTopicId: number) {
            function handleTopicLevel(outline: any) {
                const includeSubTopic = outline.sourcesSubTopic.includeSubTopic;
                if (gyanId !== undefined && gyanId !== null) {
                    if (isChecked) {
                        includeSubTopic[gyanId] = true;
                    } else {
                        includeSubTopic[gyanId] = false;
                    }
                }

                if (removeChecked) delete includeSubTopic[gyanId];

                console.log(includeSubTopic);
            }

            function processOutline(outline: any) {
                // Check if the current outline's ID matches the current topic ID
                if (outline.id === currentTopicId && gksLevel === 'topicLevel') {
                    handleTopicLevel(outline);
                } else if (outline.subtopics && outline.subtopics.length > 0) {
                    // Continue the search in nested subtopics if the ID doesn't match
                    outline.subtopics.forEach((subtopic: any) => processOutline(subtopic));
                }
            }

            // Start processing from the root topicOutline
            processOutline(topicOutline);
        }

        updateIncludeSubtopic(topicOutline, this.gksLevel, isChecked, id, this.topic.id);
        localStorage.setItem(localStorageKey_topicOutline, JSON.stringify(topicOutline));
    }
    getEnabledFormData(): any {
        // Enable all 'key' fields temporarily
        this.fields.controls.forEach((fieldGroup) => {
            fieldGroup.get('key')?.enable();
        });

        const formData = this.form.getRawValue();

        // Disable the 'key' fields again
        this.fields.controls.forEach((fieldGroup) => {
            if (fieldGroup.get('key')?.value) {
                fieldGroup.get('key')?.disable();
            }
        });
        return formData;
    }

    shouldShowDeleteButton(index: number): boolean {
        return !!this.fields.at(index).get('key')?.value;
    }

    getOptionCtrl(index: number): FormControl | null {
        const control = this.fields.at(index).get('optionCtrl');
        return control instanceof FormControl ? control : null;
    }

    // filtering options on the input, excluding the selected options
    filterOptions(index: number): void {
        const fieldGroup = this.fields.at(index) as FormGroup;
        // Get the value of the selected tag name (from the 'key' control)
        const selectedTag = fieldGroup.get('key')?.value?.idWithoutSite;
        //console.log('Selected tag:', selectedTag);

        //console.log(fieldGroup.get('optionCtrl'));
        const query = fieldGroup.get('optionCtrl')?.value || '';

        if (query === '') {
            fieldGroup.patchValue({
                showDropdown: true, // Always show the dropdown
            });
        }

        // Calling api after typing
        if (query && query.length > 1) {
            this.callApiAndFilterOptions(query, selectedTag, index);
        } else {
            // Clear filtered options if the input is empty
            fieldGroup.patchValue({ filteredOptions: [] });
        }
    }

    callApiAndFilterOptions(query: string, selectedTag: string, index: number): void {
        // Replace with your API call logic
        this.submitgyanService.getSolrData(this.selectedKnowledgeStore.uuid, selectedTag, query.toLowerCase()).subscribe({
            next: (response: any) => {
                const data = response.response.docs;
                // preparing all options from the API response
                const allOptions = Array.from(
                    new Set(
                        data.reduce((acc: any, item: any) => {
                            const value = Object.values(item)[0];
                            if (Array.isArray(value)) {
                                acc = acc.concat(value); // Concatenate array values
                            } else {
                                acc.push(value); // Add single values
                            }
                            return acc;
                        }, []),
                    ),
                );

                console.log(allOptions);
                // get selected options for this form group
                const fieldGroup = this.fields.at(index) as FormGroup;
                const selectedOptions = fieldGroup.get('selectedOptions')?.value || [];

                // removing previously selected options
                const filteredOptions = allOptions.filter((option) => !selectedOptions.includes(option));

                // checking if no options are left after filtering
                if (allOptions.length === 0) {
                    // showing "No result found"
                    fieldGroup.patchValue({
                        filteredOptions: [],
                        showDropdown: true,
                    });
                } else {
                    // updating filtered options
                    fieldGroup.patchValue({
                        filteredOptions: filteredOptions,
                        showDropdown: filteredOptions.length > 0, //true
                    });
                }
            },
            error: (error: HttpErrorResponse) => {
                console.log('Error: ', error.message);

                // if error then the dropdown shows "No result found"
                const fieldGroup = this.fields.at(index) as FormGroup;
                fieldGroup.patchValue({
                    filteredOptions: [],
                    showDropdown: true, // Ensure the dropdown is shown even on error
                });
            },
        });
    }

    // showing selected options
    selectOption(option: string, index: number): void {
        const fieldGroup = this.fields.at(index) as FormGroup;
        const selectedOptions = fieldGroup.get('selectedOptions')?.value || [];

        if (!selectedOptions.includes(option)) {
            selectedOptions.push(option);
        }

        const allOptions = fieldGroup.get('filteredOptions')?.value || [];
        const filteredOptions = allOptions.filter((opt: any) => !selectedOptions.includes(opt));

        // Update the selected options and close the dropdown
        fieldGroup.patchValue({
            selectedOptions: selectedOptions,
            optionCtrl: '', // clear input after selecting an option
            filteredOptions: filteredOptions, // Update the filtered options
            showDropdown: fieldGroup.get('filteredOptions')?.value.length > 0, // close dropdown // false
        });
    }

    // removing selected option
    remove(option: string, index: number): void {
        const fieldGroup = this.fields.at(index) as FormGroup;
        const selectedOptions = fieldGroup.get('selectedOptions')?.value || [];

        const updatedOptions = selectedOptions.filter((selected: string) => selected !== option);

        fieldGroup.patchValue({
            selectedOptions: updatedOptions,
        });

        this.filterOptions(index);
    }

    // close dropdown when clicking outside
    @HostListener('document:click', ['$event'])
    clickout(event: Event): void {
        const targetElement = event.target as HTMLElement;

        this.fields.controls.forEach((control, index) => {
            const fieldGroup = control as FormGroup;
            const optionCtrl = fieldGroup.get('optionCtrl') as FormControl;

            // checking if the click is outside of the current input field or dropdown
            if (!this.eRef.nativeElement.contains(targetElement)) {
                optionCtrl.setValue(''); // clearing input
                fieldGroup.patchValue({ showDropdown: false }); // closing dropdown
            }
        });
    }

    // when user start typing then only show dropdown
    onFocus(index: number): void {
        const optionCtrlValue = this.fields.at(index).get('optionCtrl')?.value;
        const fieldGroup = this.fields.at(index) as FormGroup;

        if (optionCtrlValue) {
            ///  showing dropdown if input has value
            fieldGroup.patchValue({ showDropdown: true });
            this.filterOptions(index);
        }
    }

    // showing dropdown when focus on input
    onInputFocus(index: number): void {
        const optionCtrlValue = this.fields.at(index).get('optionCtrl')?.value;
        const fieldGroup = this.fields.at(index) as FormGroup;

        if (optionCtrlValue) {
            //  showing dropdown if input has value
            fieldGroup.patchValue({ showDropdown: true });
        }
    }

    // showing title for +count bades
    getHiddenOptionsTitle(selectedOptions: Array<string>): string {
        const hiddenOptions = selectedOptions.slice(this.maxVisibleBadges);
        return hiddenOptions.join(', ');
    }

    // removing by pressing backspace in an empty input
    removeLastSelected(index: number): void {
        const fieldGroup = this.fields.at(index) as FormGroup;
        const optionCtrlValue = fieldGroup.get('optionCtrl')?.value;

        if (!optionCtrlValue && fieldGroup.get('selectedOptions')?.value.length > 0) {
            const selectedOptions = fieldGroup.get('selectedOptions')?.value;
            selectedOptions.pop();

            fieldGroup.patchValue({
                selectedOptions: selectedOptions,
            });

            this.filterOptions(index);
        }
    }

    checkWidth() {
        const width = window.innerWidth;
        if (width < 768) this.isMobile = true;
        else this.isMobile = false;
    }
    filteredData: any = [];
    // filterData(searchTerm: string) {
    //     if (!searchTerm) {
    //       this.filteredData = [...this.myKnowledgeStoreData];  // Reset filtered data if searchTerm is empty
    //     } else {
    //       this.filteredData = this.myKnowledgeStoreData.filter((item:any) =>
    //         item.name.toLowerCase().includes(searchTerm.toLowerCase())
    //       );
    //     }
    //   }
    onFilterDataSort() {
        this.filteredData.sort((a: any, b: any) => {
            return this.sortNamesByCategory(a.name, b.name);
        });
    }

    sortNamesByCategory(a: string, b: string): number {
        // Helper function to categorize strings based on their content
        const categorize = (str: string): number => {
            // Check if string starts with a special character (anything that is not a letter or number)
            if (/^[^a-zA-Z0-9]/.test(str)) {
                return 0; // Special characters
            }
            // Check if string starts with a number
            else if (/^\d/.test(str)) {
                return 1; // Numbers
            }
            // Otherwise, it's an alphabet
            else {
                return 2; // Alphabets
            }
        };

        // Compare based on the category (special character, number, or alphabet)
        const categoryA = categorize(a);
        const categoryB = categorize(b);

        // If categories differ, sort by category
        if (categoryA !== categoryB) {
            return categoryA - categoryB;
        }

        // If both strings belong to the same category, compare alphabetically or numerically
        return a.localeCompare(b);
    }

    filterData(searchTerm: string) {
        if (!searchTerm) {
            // Reset filtered data if searchTerm is empty
            this.filteredData = [...this.myKnowledgeStoreData];
            this.onFilterDataSort();
        } else {
            // Escape special characters in the searchTerm for safe use in RegExp
            const escapedSearchTerm = searchTerm.toLowerCase();
            //  alert('escapedSearchTerm');
            // alert(escapedSearchTerm);
            if (escapedSearchTerm.length > 0) {
                // Filter items where name contains the searchTerm (case insensitive, special characters supported)
                this.filteredData = this.myKnowledgeStoreData.filter((item: any) => {
                    return item.name.toLowerCase().includes(escapedSearchTerm);
                });

                this.onFilterDataSort();
            } else {
                this.filteredData = [];
                this.onFilterDataSort();
            }
        }
    }

    // Function to escape special characters for use in a regular expression
    escapeRegExp(str: string) {
        return str.replace(/[.*+?^=!:${}()|\[\]\/\\]/g, '\\$&');
    }

    // Custom function for comparing strings that handles all characters, including special ones
    compareStrings(a: string, b: string) {
        // Convert both strings to lowercase for case-insensitive comparison
        const aNormalized = a.toLowerCase();
        const bNormalized = b.toLowerCase();

        // Perform the comparison
        if (aNormalized < bNormalized) return -1; // a comes before b
        if (aNormalized > bNormalized) return 1; // a comes after b
        return 0; // a and b are equal
    }
    onSearchInput(value: string) {
        console.log('onSearchInput.value', value);
        this.filteredData = [...this.myKnowledgeStoreData];

        // const sanitizedValue = this.sanitizeService.sanitizeInput(value);

        // // Only update and emit if the sanitized value differs
        // if (value !== sanitizedValue) {
        //     value = sanitizedValue;
        // }
        this.filterData(value);
        // this.findText = value;
        // this.findBySearchNameInputSubject.next(value);
    }
}
